import * as S from "@/containers/ProjectTemplate/styled";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { Button, Modal } from "antd";
import { useIntl } from "react-intl";
import { IErrorProps } from "../interfaces";

interface IProps {
  modalState: IErrorProps;
  closeModal: () => void;
}
const ProjectTemplateErrorModal = ({ modalState, closeModal }: IProps) => {
  const intl = useIntl();
  const projectCompleteErrorMessage = intl.formatMessage({
    id: "entityStatusInput.noProjectCompleteMilestone",
  });

  // Check if an error is the project complete error message (top-level error)
  const isProjectCompleteError = (message: string): boolean =>
    message === projectCompleteErrorMessage;

  // Separate errors into project complete errors and milestone names
  const projectCompleteErrors = modalState.errors.filter((msg) =>
    isProjectCompleteError(msg)
  );
  const milestoneNames = modalState.errors.filter(
    (msg) => !isProjectCompleteError(msg)
  );

  return (
    <Modal
      open={modalState.visible}
      title={modalState.title}
      width={600}
      closable
      maskClosable
      onCancel={(): void => {
        closeModal();
      }}
      footer={[
        <Button
          key="submit"
          type="primary"
          onClick={(): void => {
            closeModal();
          }}
          data-test-id="project-template-error-modal-ok"
        >
          {intl.formatMessage({ id: "general.close" })}
        </Button>,
      ]}
    >
      <S.CenteredIconContainer>
        <S.ProjectTemplateErrorModalAlertIcon
          icon={faTriangleExclamation as IconProp}
        />
      </S.CenteredIconContainer>
      <S.ProjectTemplateErrorModalTextContainer>
        {(modalState.description || modalState.errors.length > 0) && (
          <ul style={{ margin: 0, paddingLeft: "20px" }}>
            {projectCompleteErrors.map((message, index) => (
              <li key={index} className="font-bold">
                {message}
              </li>
            ))}
            {modalState.description && (
              <li
                className="font-bold"
                style={{
                  marginTop: projectCompleteErrors.length > 0 ? "8px" : "0",
                  marginBottom: milestoneNames.length > 0 ? "8px" : "0",
                }}
              >
                {modalState.description}
                {milestoneNames.length > 0 && (
                  <ul
                    style={{
                      marginTop: "8px",
                      marginBottom: "0",
                      paddingLeft: "20px",
                    }}
                  >
                    {milestoneNames.map((message, index) => (
                      <li key={index} className="font-bold">
                        {message}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            )}
          </ul>
        )}
      </S.ProjectTemplateErrorModalTextContainer>
    </Modal>
  );
};

export { ProjectTemplateErrorModal };
